import { render, staticRenderFns } from "./CannotAccess.vue?vue&type=template&id=12c1012e"
import script from "./CannotAccess.vue?vue&type=script&lang=js"
export * from "./CannotAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports